import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import PubSub from 'services/PubSub/';
import { addClass, removeClass } from 'utils';
import style from './style.scss'; //NOSONAR

let actions = {};

const Modal = (props) => {
    const [modalOpen, setModalOpen] = useState(false);
    const callback = props.callback ? props.callback : null;
    const {actionOpen, actionClose, customClass} = props;

    const modalId = actionOpen;

    useEffect(() => {
        if(!actions[modalId]){
            actions[modalId] = [];
        }

        if(typeof document !== 'undefined') document.addEventListener('keydown', _keyDown);
        actions[modalId].push(PubSub.register(actionOpen, _open));
        actions[modalId].push(PubSub.register(actionClose, _close));

        return function cleanup() {
            actions[modalId].map(token => PubSub.unregister(token));
            if(typeof document !== 'undefined') document.removeEventListener('keydown', _keyDown);
            actions[modalId] = [];
        }
    }, []);

    const _open = () => {
        setModalOpen(true);
    }
    const _close = () => {
        setModalOpen(false);
    }

    const _keyDown = (data) => {
        if(data.keyCode === 27){
            setModalOpen(false);
        }
    }

    const clickClose = () => {
        if(callback){
            callback();
        }
        setModalOpen(false);
    }

    if(typeof document !== 'undefined'){
        if(modalOpen){
            addClass(document.documentElement, 'non-scroll');
        }else{
            removeClass(document.documentElement, 'non-scroll');
        }
    }

    return (
        modalOpen && <section className={'new-modal ' + (customClass ? customClass : '')}>
            <div className={'new-modal-content'}>
                <button className="new-modal-close font-icn jumbo-icon-new-close" onClick={clickClose} />
                {props.children}
            </div>
            <div className="new-modal-overlay" onClick={clickClose} />
        </section>
    )
}

Modal.propTypes = {
    customClass: PropTypes.string,
    open: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
        PropTypes.object,
        PropTypes.node
    ]),
    callback: PropTypes.func,
    actionOpen: PropTypes.string,
    actionClose: PropTypes.string

}

export default Modal;
